export const scrollToLowestWidget = () => {
  const scrollWrapper = document.getElementById("main-wrapper");

  if (scrollWrapper) {
    scrollWrapper.scrollTo({
      top: scrollWrapper.scrollHeight,
      left: scrollWrapper.scrollWidth,
      behavior: "smooth"
    });
  }
};